import { useStore } from "@/store";

/**
 * Custom hook to access and manage auth data from the Zustand store
 */
export const useUser = () => {
  const {
    currentUser,
    userData,
    isUserLoading,
    error,
    setCurrentUser,
    subscribeToUserData,
    setCurrentPageId,
    setCurrentDomainId,
  } = useStore();

  return {
    currentUser,
    userData,
    currentDomainId: userData?.currentDomainId,
    currentPageId: userData?.currentPageId,
    isUserLoading,
    error,
    setCurrentUser,
    subscribeToUserData,
    setCurrentDomainId,
    setCurrentPageId,
  };
};
